import posthog from 'posthog-js';

let initialized = false;

export default function usePostHog() {
	if (!initialized) {
		posthog.init('phc_EaWdDlR1AysICk7VZzwlesjUJ97lm7zYwNHBEdC3ulX', {
			api_host: 'https://eu.i.posthog.com',
			defaults: '2025-05-24',
			person_profiles: 'always',
		});
		initialized = true;
	}

	return { posthog };
}
